import type { ItemHit } from "@amber/application/contracts";
import type { PassageHit, SnippetSegment } from "@amber/evidence/contracts";

export const PLACEHOLDER = "Search items, transcripts, people or paste a URL";

export function Snippet({ segments }: { segments: readonly SnippetSegment[] }) {
  return (
    <>
      {segments.map((s, i) =>
        s.match ? (
          <mark key={i} className="rounded-sm bg-accent-soft px-px text-fg">
            {s.text}
          </mark>
        ) : (
          <span key={i}>{s.text}</span>
        ),
      )}
    </>
  );
}

export function timeLabel(ms: number | null): string | null {
  if (ms === null) return null;
  const total = Math.floor(ms / 1000);
  return `${String(Math.floor(total / 60))}:${String(total % 60).padStart(2, "0")}`;
}

export const statusTone = (status: ItemHit["status"]) => {
  if (status === "failed") return "font-strong text-attention";
  if (status === "waiting") return "font-strong text-waiting";
  return "text-muted";
};

export const itemMeta = (item: ItemHit) =>
  [item.people.join(", "), item.platform.label, item.channel].filter((v) => v && v.length > 0).join(" · ");
export const itemStatus = (item: ItemHit) => `${item.status_label}${item.readiness ? ` · ${item.readiness}` : ""}`;
export const passageMeta = (p: PassageHit) =>
  [
    p.title,
    p.other_copies > 0 ? `+${String(p.other_copies)} ${p.other_copies === 1 ? "copy" : "copies"}` : null,
    p.corrected ? "Corrected" : null,
  ]
    .filter(Boolean)
    .join(" · ");

export const LIFECYCLE_LABELS: Record<string, string> = {
  draft: "Not tracked",
  active: "Tracked",
  paused: "Paused",
  archived: "Archived",
  incidental: "Not tracked",
};
